import { LogSentEmailActivityMutation, LogSentEmailActivityMutationVariables } from 'types/graphql'

import { useMutation } from 'src/utils/queryClient'

const LogSentEmailActivity = gql`
  mutation LogSentEmailActivityMutation($input: LogSentEmailActivityInput!) {
    logSentEmailActivity(input: $input)
  }
`

export const useLogSentEmailActivityMutation = () => {
  return useMutation<LogSentEmailActivityMutation, LogSentEmailActivityMutationVariables>({
    mutationDocument: LogSentEmailActivity,
  })
}
